import FeatureRules from './FeatureRules';
import * as useFeatureBfcm from './useFeatureBfcm';

export default new FeatureRules([useFeatureBfcm]);
